import { Translations, TranslationsPlatform } from 'services/translations'
import { TranslationsMessages } from '@runelab/odin-common/src/services/translations/types'
import { masterAxios } from 'api/config'

export const mapTranslationsToMessages = (translations: Translations[]): TranslationsMessages => {
  return translations.reduce((acc, translation) => {
    return {
      ...acc,
      [translation.key]: translation.value,
    }
  }, {})
}

export const getAppTranslations = async (language: Translations['language']) => {
  const { data: translations } = await masterAxios.get<Translations[]>('translations', {
    params: {
      language,
      platform: TranslationsPlatform.APP,
    },
  })
  return mapTranslationsToMessages(translations)
}
